// Theme management utilities

/**
 * Set theme according to preference
 * @param isDarkMode whether to enable dark mode
 */
export const setTheme = (isDarkMode: boolean | null): void => {
  if (isDarkMode === null) {
    // If null, use system preference
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.remove('light');
    
    // Apply system preference immediately
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.add('light');
    }
    
    localStorage.removeItem('theme');
  } else if (isDarkMode) {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.remove('light');
    localStorage.setItem('theme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
    localStorage.setItem('theme', 'light');
  }
};

/**
 * Get saved theme from localStorage or use system preference
 * @returns boolean | null - true for dark, false for light, null for system preference
 */
export const getPreferredTheme = (): boolean | null => {
  // Check if theme is saved in localStorage
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme === 'dark') return true;
  if (savedTheme === 'light') return false;
  
  // If not saved, return null to indicate system preference
  return null;
};

/**
 * Get the current effective theme considering system preference
 * @returns boolean - true if dark mode is active
 */
export const getEffectiveTheme = (): boolean => {
  const preference = getPreferredTheme();
  
  // If explicit preference is set, use it
  if (preference !== null) return preference;
  
  // Otherwise use system preference
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}; 